import { UploadFile } from "antd";
import { Document, MediaProjectResponse } from "../../types";
import { Step } from "../components/ProjectCreateWizard";
import { AGGREGATED_DOCUMENT_NAME } from "hooks/useUploadFiles";
import { ALL_PAGES_VALUE } from "../components/ProjectSettingsFormSteps/ProjectSettingsFormSelectedPages";
import { ReservedProjectTags } from "../types";

export const getStoryboardAndInstanceData = (
  projectData: MediaProjectResponse | undefined,
  params: { storyboardId?: string },
  isEdit: boolean
) => {
  const storyboardId = isEdit
    ? (params.storyboardId ?? projectData?.storyboards?.[0]?.id)
    : projectData?.storyboards?.[0]?.id;

  const storyboardSettings = projectData?.storyboards?.find(
    (item) => item.id === storyboardId
  );

  const instanceSettings = projectData?.media?.find(
    (item) => item.storyboard_settings_id === storyboardId
  );

  const instanceId = instanceSettings?.instance_id;

  return {
    storyboardId,
    storyboardSettings,
    instanceId,
    instanceSettings,
  };
};

export const filterOutUploadStepIfIsEditMode = (
  steps: Step[],
  _isEdit: boolean
) => steps;

export const filterUniqueFiles = (files: UploadFile[] = []): UploadFile[] => {
  return files.reduce((acc, file) => {
    if (!acc.some((f) => f.uid === file.uid)) {
      acc.push(file);
    }
    return acc;
  }, [] as UploadFile[]);
};

export const convertProjectDocumentsToUploadFiles = (
  documents: Document[]
): UploadFile[] => {
  if (!documents) return;
  return documents
    .filter((document) => document.name !== AGGREGATED_DOCUMENT_NAME)
    .map((document) => ({
      uid: document.id,
      name: document.name,
      url: document.path,
    }));
};

export const splitSelectedPagesValueByFile = (
  value?: string,
  uploadedFiles: UploadFile[] = []
): Record<number, string> => {
  if (value?.includes(";")) {
    const pages = value.split(";");
    return pages.reduce((acc, page, index) => ({ ...acc, [index]: page }), {});
  }
  if (uploadedFiles.length > 1) {
    return uploadedFiles?.reduce(
      (acc, _file, index) => ({ ...acc, [index]: ALL_PAGES_VALUE }),
      {}
    );
  }
  return { [0]: value || ALL_PAGES_VALUE };
};

export const isReservedProjectTag = (tagKey: string) => {
  return Object.values(ReservedProjectTags).includes(
    tagKey as ReservedProjectTags
  );
};
